import store from '@/store'
import Layout from '@/layouts/RouterView'
import { hasServices, featureMenuHiddenCheck } from '@/utils/auth'
import i18n from '@/locales'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

// 费用
const BillConfigCreate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/billshield/create')
const Project = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/project')
const ExternalProject = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/external-project')
const ExchangeRate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/exchangerate')
const ExchangeRateCreate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/exchangerate/create')
const BillBudget = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/budget')
const BillBudgetCreate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/budget/create')
const BillBudgetAlert = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/budget/create/alert')
const BillPredict = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/predict')
const Overview = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/overview')
const Account = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/account')
const Statistics = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/statistic')
const Analysis = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/analysis')
const AnalysisReport = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/analysis-report')
const AnalysisAlarm = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/analysis-alarm')
const AnalysisAlarmCreate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/analysis-alarm/Create')
const Domain = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/domain')
const Tag = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/tag')
const Time = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/time')
const ResourceType = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/resourcetype')
const OriginResourceType = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/originrestype')
const ProductType = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/producttype')
const Summary = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/summary')
const CostConversion = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/costconversion')
const CostConversionCreate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/costconversion/create')
// const Associate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/associate')
const MonthlyDetail = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/monthly-detail')
const Detail = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/detail')
const SubscriptionCreate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/summary/form/Subscription/create')
const BillConfig = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/billshield')
const ServerPriceComparatorCreate = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Cloudenv/views/server-price-comparator/create')
const PriceComparatorList = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Cloudenv/views/server-price-comparator')
const RateSet = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/rateset')
const ResourceTag = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/resource-tag')
const OfflineExport = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/offline-export')
const Products = () => import(/* webpackChunkName: "bill" */ /* webpackPrefetch: true */ '@Bill/views/products')

// 优化建议
const SuggestsOverview = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Subscription/views/suggestsOverview')
const Alert = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Subscription/views/alert')
const AlertSetting = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Subscription/views/alert-setting')
const SuggestsAlert = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsalert')
const SuggestsRule = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestionrule')
const SuggestsRuleConfig = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsysruleconfig')
const SuggestsReport = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsreport')

export default {
  index: 80,
  meta: {
    label: () => process.env.VUE_APP_PLATFORM === 'operation' ? i18n.t('bill.text_34') : i18n.t('dictionary.menu_billing_accuracy'),
    t: 'dictionary.menu_billing_accuracy',
    icon: 'menu-meter',
    hidden: () => !hasServices('billing'),
  },
  menus: [
    /**
     * 费用总览
     */
    {
      meta: {
        label: i18n.t('bill.bill_overview'),
        labelAlias: i18n.t('bill.bill_overview'),
      },
      subGroup: 'bill',
      submenus: [
        {
          path: '/billoverview',
          meta: {
            label: i18n.t('bill.bill_overview'),
            permission: 'meter_dashboard_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billoverview')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillOverview',
              path: '',
              component: Overview,
              meta: {
                key: '/billoverview',
                keepAlive: true,
                keepAliveViews: ['BillAnalysis'],
              },
            },
          ],
        },
      ],
    },
    // 费用分析
    {
      meta: {
        label: i18n.t('bill.text_245'),
        labelAlias: i18n.t('bill.text_245'),
      },
      subGroup: 'bill',
      submenus: [
        {
          path: '/billaccount',
          meta: {
            label: i18n.t('bill.account_cost'),
            permission: 'meter_dashboard_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billaccount')) {
                return true
              }
              if (!store.getters.isAdminMode && !store.getters.isDomainMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillAccountList',
              path: '',
              component: Account,
            },
          ],
        },
        {
          path: '/billstatistic',
          meta: {
            label: i18n.t('bill.brand_cost'),
            permission: 'meter_platforms_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billstatistic')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillStatistic',
              path: '',
              component: Statistics,
            },
          ],
        },
        {
          path: '/billdomain',
          meta: {
            label: () => { return i18n.t('bill.domain_cost') },
            permission: 'meter_domains_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billdomain')) {
                return true
              }
              if (!store.getters.l3PermissionEnable) {
                return true
              }
              if (!store.getters.isAdminMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillDomainList',
              path: '',
              component: Domain,
            },
          ],
        },
        {
          path: '/billproject',
          meta: {
            label: () => { return i18n.t('bill.project_cost') },
            permission: 'meter_projects_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billproject')) {
                return true
              }
              if (!(store.getters.isAdminMode || store.getters.isDomainMode)) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillProjectList',
              path: '',
              component: Project,
            },
          ],
        },
        {
          path: '/billtag',
          meta: {
            label: i18n.t('bill.tag_cost'),
            permission: 'bill_tags_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billtag')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillTagList',
              path: '',
              component: Tag,
            },
          ],
        },
        {
          path: '/billtime',
          meta: {
            label: i18n.t('bill.month_cost'),
            permission: 'meter_times_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billtime')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillTimeList',
              path: '',
              component: Time,
            },
          ],
        },
        {
          path: '/billresourcetype',
          meta: {
            label: i18n.t('bill.resource_type_cost'),
            permission: 'meter_resources_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billresourcetype')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillResourceTypeList',
              path: '',
              component: ResourceType,
            },
          ],
        },
        {
          path: '/billoriginresourcetype',
          meta: {
            label: i18n.t('bill.origin_res_type_cost'),
            permission: 'meter_cloud_resources_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billoriginresourcetype')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillOriginResourceTypeIndex',
              path: '',
              component: OriginResourceType,
            },
          ],
        },
        {
          path: '/billexternalproject',
          meta: {
            label: () => { return i18n.t('bill.external_project_cost') },
            permission: 'meter_cloud_projects_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billexternalproject')) {
                return true
              }
              if (!(store.getters.isAdminMode || store.getters.isDomainMode)) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillExternalProjectList',
              path: '',
              component: ExternalProject,
            },
          ],
        },
        {
          path: '/billproducttype',
          meta: {
            label: i18n.t('bill.product_type'),
            permission: 'bill_analysises_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billproducttype')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillProductTypeIndex',
              path: '',
              component: ProductType,
            },
          ],
        },
      ],
    },
    // 多维度分析
    {
      meta: {
        label: i18n.t('bill.text_118'),
        labelAlias: i18n.t('bill.text_118'),
      },
      subGroup: 'bill',
      submenus: [
        {
          path: '/billanalysis',
          meta: {
            label: i18n.t('bill.text_247'),
            permission: 'bill_analysises_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billanalysis')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillAnalysis',
              path: '',
              component: Analysis,
              meta: {
                key: '/billanalysis',
                keepAlive: true,
                keepAliveViews: ['BillMonthlyDetail', 'BillDetail'],
              },
            },
          ],
        },
        {
          path: '/billanalysis-report',
          meta: {
            label: i18n.t('bill.analysis_report'),
            permission: 'bill_analysis_reports_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billanalysis_report')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillAnalysisReport',
              path: '',
              component: AnalysisReport,
            },
          ],
        },
        {
          path: '/billanalysis-alarm',
          meta: {
            label: i18n.t('bill.analysis_cost_alarm'),
            permission: 'bill_analysis_alarms_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billanalysis_alarm')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillAnalysisAlarm',
              path: '',
              component: AnalysisAlarm,
            },
            {
              name: 'BillAnalysisAlarmCreate',
              path: 'create',
              component: AnalysisAlarmCreate,
            },
          ],
        },
      ],
    },
    /**
     * 报表
     */
    {
      meta: {
        label: i18n.t('bill.report'),
        labelAlias: '预算报表',
      },
      subGroup: 'bill',
      submenus: [
        {
          path: '/budget',
          meta: {
            label: i18n.t('bill.budget'),
            permission: 'bill_budgets_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.budget')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillBudget',
              path: '',
              component: BillBudget,
            },
            {
              name: 'BillBudgetCreate',
              path: 'create',
              component: BillBudgetCreate,
            },
            {
              name: 'BillBudgetAlertCreate',
              path: 'create_alert',
              component: BillBudgetAlert,
            },
          ],
        },
        {
          path: '/predict',
          meta: {
            label: i18n.t('bill.predict_management'),
            permission: 'bill_predictions_query',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.predict')) {
                return true
              }
              if (!store.state.common.bill.globalConfig?.enable_prediction) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillPredict',
              path: '',
              component: BillPredict,
            },
          ],
        },
      ],
    },
    /**
     * 账单
     */
    {
      meta: {
        label: i18n.t('bill.text_249'),
        labelAlias: '费用账单',
      },
      subGroup: 'bill',
      submenus: [
        {
          path: '/billsummary',
          meta: {
            label: i18n.t('bill.summary'),
            permission: 'meter_summary_bills',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billsummary')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillSummary',
              path: '',
              component: Summary,
            },
            {
              name: 'BillSubscriptionCreate',
              path: 'subscriptioncreate',
              component: SubscriptionCreate,
            },
          ],
        },
        {
          path: '/bill-monthlydetail',
          meta: {
            label: i18n.t('bill.monthly_bill_detail'),
            permission: 'meter_monthly_bills',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.bill_monthlydetail')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillMonthlyDetail',
              path: '',
              component: MonthlyDetail,
            },
          ],
        },
        {
          path: '/bill-dailydetail',
          meta: {
            label: i18n.t('bill.daily_bill_detail'),
            permission: 'meter_daily_bills',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.bill_dailydetail')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillDetail',
              path: '',
              component: Detail,
            },
          ],
        },
        {
          path: '/offline-export',
          meta: {
            label: i18n.t('common.offline_export'),
            permission: 'offline_exports_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.offline_export')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'OfflineExport',
              path: '',
              component: OfflineExport,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('cloudenv.price_comparison'),
        permission: 'server_list,meter_price_matchers',
        hidden: (userInfo, menu) => {
          return featureMenuHiddenCheck(menu)
        },
      },
      subGroup: 'bill',
      submenus: [
        {
          path: '/pricecomparator',
          meta: {
            label: i18n.t('cloudenv.price_list'),
            permission: 'servers_list,meter_price_matchers',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.pricecomparator')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'PriceComparatorList',
              path: '',
              component: PriceComparatorList,
            },
            {
              name: 'PriceComparatorCreate',
              path: 'create',
              component: ServerPriceComparatorCreate,
            },
          ],
        },
      ],
    },
    /**
     * 分析
     */
    {
      meta: {
        label: i18n.t('bill.advanced_settings'),
        // hidden: () => !store.getters.isAdminMode,
      },
      subGroup: 'bill',
      submenus: [
        {
          path: '/billrate',
          meta: {
            label: i18n.t('bill.text_38'),
            t: 'bill.text_38',
            permission: 'bill_ratesets_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billrate')) {
                return true
              }

              return featureMenuHiddenCheck(menu) || !store.getters.isAdminMode
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillRateSet',
              path: '',
              component: RateSet,
            },
          ],
        },
        {
          path: '/resource-tag',
          meta: {
            label: i18n.t('bill.resource_tag'),
            t: 'bill.resource_tag',
            permission: 'meter_instances_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.resource_tag')) {
                return true
              }
              if (isScopedPolicyMenuHidden('fee_hidden_items.instance_tag')) {
                return true
              }
              if (!store.getters.isAdminMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillResourceTag',
              path: '',
              component: ResourceTag,
            },
          ],
        },
        {
          path: '/cost-conversion',
          meta: {
            label: i18n.t('bill.cost_conversion'),
            permission: 'cost_conversions_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.cost_conversion')) {
                return true
              }
              if (!store.getters.isAdminMode || !store.state.common.bill.globalConfig?.cost_conversion_available) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'CostConversion',
              path: '',
              component: CostConversion,
            },
            {
              name: 'CostConversionCreate',
              path: 'create',
              component: CostConversionCreate,
            },
          ],
        },
        {
          path: '/billexchangerate',
          meta: {
            label: i18n.t('bill.text_285'),
            permission: 'rates_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.billexchangerate')) {
                return true
              }
              // 全局设置开关关闭，隐藏页面
              if (!store.state.common.bill.exchangeRateAvailable) {
                return true
              }
              if (!store.getters.isAdminMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillExchangeRate',
              path: '',
              component: ExchangeRate,
            },
            {
              name: 'BillExchangeRateCreate',
              path: 'create',
              component: ExchangeRateCreate,
            },
          ],
        },
        {
          path: '/bill-config',
          meta: {
            label: i18n.t('bill.bill_config'),
            permission: 'shieldbills_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.bill_config')) {
                return true
              }
              if (!store.getters.isAdminMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillConfig',
              path: '',
              component: BillConfig,
            },
            {
              name: 'BillConfigCreate',
              path: 'create',
              component: BillConfigCreate,
            },
          ],
        },
        {
          path: '/bill-product',
          meta: {
            label: i18n.t('bill.product_type_maintenance'),
            permission: 'bill_products_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.bill_product')) {
                return true
              }
              if (!store.getters.isAdminMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'BillProduct',
              path: '',
              component: Products,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.text_253'),
        hidden: () => !hasServices('suggestion'),
      },
      subGroup: 'suggestion',
      submenus: [
        {
          path: '/suggestsyoverview',
          meta: {
            label: i18n.t('bill.suggestsy_overview'),
            permission: 'suggestsysalerts_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsyoverview')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsOverview',
              path: '',
              component: SuggestsOverview,
            },
          ],
        },
        {
          path: '/suggestsysrule',
          meta: {
            label: i18n.t('meter.suggestion_rule'),
            permission: 'suggestsysrules_list',
            // hidden: () => !store.getters.isAdminMode, // show rule for all views
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysrule')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsRule',
              path: '',
              component: SuggestsRule,
              // props: { title: i18n.t('meter.accuracy_rule_setting') },
            },
          ],
        },
        {
          path: '/suggestsysalert',
          meta: {
            label: i18n.t('meter.accuracy_suggestion_list'),
            permission: 'suggestsysalerts_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysalert')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsAlert',
              path: '',
              component: SuggestsAlert,
              props: { title: i18n.t('meter.accuracy_suggestion_list') },
            },
          ],
        },
        {
          path: '/suggestsysruleconfig',
          meta: {
            label: i18n.t('meter.accuracy_ignore_list'),
            permission: 'suggestsysrules_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysruleconfig')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsRuleConfig',
              path: '',
              component: SuggestsRuleConfig,
              props: { title: i18n.t('meter.accuracy_ignore_list') },
            },
          ],
        },
        {
          path: '/suggestsysreport',
          meta: {
            label: i18n.t('meter.suggest_analysis'),
            permission: 'suggestsysalertsreport_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.suggestsysreport')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'SuggestsReport',
              path: '',
              component: SuggestsReport,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('subscription.abnormal_consumption'),
      },
      subGroup: 'suggestion',
      submenus: [
        {
          path: '/alert',
          meta: {
            label: i18n.t('subscription.alert_list'),
            permission: 'bill_alerts_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.alert')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'Alert',
              path: '',
              component: Alert,
            },
          ],
        },
        {
          path: '/alert-setting',
          meta: {
            label: i18n.t('meter.alert_rule_setting'),
            permission: 'bill_alert_settings_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.alert_setting')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'AlertSetting',
              path: '',
              component: AlertSetting,
              props: { title: i18n.t('meter.alert_rule_setting') },
            },
          ],
        },
      ],
    },
  ],
}
